import { GHARS, PATHIS, PREACHERS, cellTime, withHonorific } from "../data/rssbData";

const byId = () => Object.fromEntries([...PREACHERS, ...PATHIS].map((p) => [p.id, p]));

// people in one cell: [{ key, name }]
const peopleOf = (c, people) => {
  if (!c || c.type === "CD" || c.type === "LCD") return [];
  const out = [];
  const add = (id, custom) => {
    if (id) out.push({ key: `id:${id}`, name: people[id] ? withHonorific(people[id]) : id });
    else if (custom && !/\(PDF/.test(custom)) out.push({ key: `n:${custom.trim()}`, name: custom.trim() });
  };
  add(c.preacherId, c.customPreacher);
  add(c.pathiId, c.customPathi);
  return out;
};

// every sewa on one date: { personKey: [{ gid, ghar, time }] }
export function dutiesOn(variant, iso) {
  const people = byId();
  const map = {};
  GHARS.forEach((g) => {
    const c = variant?.cells?.[g.id]?.[iso];
    peopleOf(c, people).forEach(({ key }) => (map[key] = map[key] || []).push({ gid: g.id, ghar: g.hi, time: cellTime(c, iso) }));
  });
  return map;
}

// same person, same date, same time at 2+ ghars
export function findClashes(variant, dates) {
  const people = byId();
  const cells = new Set();
  const list = [];
  dates.forEach((d) => {
    const slots = {};
    GHARS.forEach((g) => {
      const c = variant?.cells?.[g.id]?.[d.iso];
      const time = cellTime(c, d.iso);
      peopleOf(c, people).forEach(({ key, name }) => {
        const k = `${key}|${time}`;
        (slots[k] = slots[k] || { name, time, iso: d.iso, at: [] }).at.push(g);
      });
    });
    Object.values(slots)
      .filter((s) => s.at.length > 1)
      .forEach((s) => {
        s.at.forEach((g) => cells.add(`${g.id}|${s.iso}`));
        list.push({ ...s, ghars: s.at.map((g) => g.hi) });
      });
  });
  return { cells, list };
}
